<template>
  <div id="cme-footer"
       @contextmenu.prevent=""
       v-if="$store.state.tagData.indexOf('ext_wz_foot')>-1">
    <div class="z-container">
      <div class="main">
        <div class="footer-left">
          <div class="center-title"
               v-if="tagData.indexOf('ext_wz_line')>-1">{{languageData.serviceHotline}}</div>
          <div class="center-tel"
               v-if="tagData.indexOf('ext_wz_tel')>-1">{{footData.serviceHotlineNum}}</div>
        </div>
        <div class="footer-center">
          <div class="center-title"
               :title="languageData.contactAddress"
               v-if="tagData.indexOf('ext_wz_address_title')>-1">{{languageData.contactAddress}}</div>
          <div class="center-num"
               :title="`${languageData.telephone}：${footData.telPhone}`"
               v-if="tagData.indexOf('ext_wz_tel')>-1">{{languageData.telephone}}：{{footData.telPhone}}</div>
          <div class="center-num"
               :title="`${languageData.mailbox}：${footData.email}`"
               v-if="tagData.indexOf('ext_wz_email')>-1">{{languageData.mailbox}}：{{footData.email}}</div>
          <div class="center-num"
               :title="`${languageData.address}：${footData.address}`"
               v-if="tagData.indexOf('ext_wz_address')>-1">{{languageData.address}}：{{footData.address}}</div>
        </div>
        <div class="footer-right">
            <div class="footer-scan" v-if="tagData.indexOf('ext_wz_QR1')>-1">
              <div class="img">
                <img v-show="footData.weChatOfficialAccountQRCodeImage" id="QR_code"
                   :src="footData.weChatOfficialAccountQRCodeImage" />
              </div>
            </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div id="cme-bottom"
         v-if="tagData.indexOf('ext_wz_copy_info')>-1">
      <div class="z-container">
        <span>声明：本站部分文章、图片来源于网络，为第三方供稿，著作权归原作者所有，本站不承担因第三方所供稿件而产生的相关责任。如有侵权，请联系本站删除。</span>
        <span>
          <span v-if="tagData.indexOf('ext_wz_copyright')>-1">
            {{footData.bottomCopyright?footData.bottomCopyright:'©2016-' + that.$dataTime.getFullYear() + ' 共享世界 520emv.com 版权所有 保留所有权利'}}
          </span>
          <span v-if="tagData.indexOf('ext_wz_records')>-1">
            <a @click.prevent="openWinBlank(footData.bottomCopyrightNumUrl)"
              href="javascript:;">
              {{footData.bottomCopyrightNum?footData.bottomCopyrightNum:'豫ICP备16016646号-1'}}
            </a>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data () {
    return {
      footNavList: [],
      footData: {},
      ovImg: 1,
      showData: false,
      that:window
    };
  },
  computed: {
    languageData () {
      return this.$store.state.languageData;
    },
    tagData () {
      return this.$store.state.tagData;
    }
  },
  mounted () {
    this.getFootNav();
    this.getServiceData();
  },
  methods: {
    openWinBlank (url) {
      if (url && url != 'javascript:;') {
        this.open(url, '_blank','版权信息');
      }
    },
    getServiceData () {
      this.$http
        .get("/zciid-deliverable/business/bAppOqmidPage/getDataForOqimd.json", {
          appId: this.$appId
        })
        .then(res => {
          if (res.state == 1) {
            this.showData = true;
          }
          res.data ? '' : (res.data = {});
          res.data.serviceHotlineNum ? '' : (res.data.serviceHotlineNum = '400-670-6518');
          res.data.telPhone ? '' : (res.data.telPhone = '15901250582');
          res.data.email ? '' : (res.data.email = 'zjsq@zjsqe.com');
          res.data.address ? '' : (res.data.address = '河南省郑州市金水区黄河路天一大厦');
          res.data.weChatOfficialAccountQRCodeImage ? '' : (res.data.weChatOfficialAccountQRCodeImage = window.location.origin + '/zjstatic/standard/images/abduction_website.png');
          res.data.weChatCmsAccountQRCodeImage ? '' : (res.data.weChatCmsAccountQRCodeImage = window.location.origin + '/zjstatic/standard/images/abduction_account.png');
          res.data.sinaAccountQRCodeImage ? '' : (res.data.sinaAccountQRCodeImage = window.location.origin + '/zjstatic/standard/images/abduction_card.png');
          res.data.weChatOfficialAccountTitle ? '' : (res.data.weChatOfficialAccountTitle = '官网');
          res.data.weChatCmsAccountTitle ? '' : (res.data.weChatCmsAccountTitle = '公众号');
          res.data.sinaAccountTitle ? '' : (res.data.sinaAccountTitle = '名片');

          this.footData = res.data;
        })
      
    },
    getFootNav () {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorNavList.json", {
          ...this.$route.query
        })
        .then(res => {
          if (res.state == 1) {
            if (res.data.bottomNavArr) {
              this.footNavList = res.data.bottomNavArr.splice(0, 3);
            }
          }

        });
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/css/theme/index.scss";
// @import "~@/assets/css/footer.scss";
</style>
<style >
/*cme-footer 开始*/
#cme-footer {
  width: 100%;
  padding-top: 8px;
  margin-top: 32px;
  font-size: 12px;
  overflow: hidden;
  background-color: #1b2b46;
  /* 过年主题 */
  /* background-color: #b80400; */
}
#cme-footer .main {
  margin: 0 auto;
  padding-top: 30px;
  height: 140px;
}
#cme-footer .main .footer-left {
  float: left;
  background: url("~@/assets/images/footer_line.png") no-repeat right center;
  /* 过年主题 */
  /* background: url("~@/assets/images/image_red.png") no-repeat right center; */
}
#cme-footer .main .footer-left .center-tel {
  border-top: 1px solid #4b5b6e;
  border-bottom: 1px solid #4b5b6e;
  /* 过年主题 */
  /* border-top: 1px solid #cd504d;
  border-bottom: 1px solid #cd504d; */


  width: 270px;
  font-size: 30px;
  line-height: 56px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #8795a6;
  /* 过年主题 */
  /* color: #fdbdbd; */
}
#cme-footer .main .footer-left .center-title {
  width: 270px;
  font-size: 18px;
  padding-left: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #8795a6;
  background: url("~@/assets/images/icons/footer_icon_tel.png") no-repeat left
    center;
  /* 过年主题 */
  /* color: #fdbdbd;
  background: url("~@/assets/images/icons/customer_service.png") no-repeat left
    center; */
  
}
#cme-footer .main .footer-center {
  float: left;
  width: 480px;
  margin-left: 60px;
  background: url("~@/assets/images/footer_line.png") no-repeat right center;
  /* 过年主题 */
  /* background: url("~@/assets/images/image_red.png") no-repeat right center; */
}
#cme-footer .main .footer-center .center-title {
  width: 270px;
  font-size: 18px;
  padding-left: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #8795a6;
  background: url("~@/assets/images/icons/footer_icon_follow.png") no-repeat
    left center;
  /* 过年主题 */
  /* color: #fdbdbd;
  background: url("~@/assets/images/icons/contact_address.png") no-repeat left
    center; */
}
#cme-footer .main .footer-center .center-num {
  width: 440px;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  color: #8795a6;
  /* 过年主题 */
  /* color: #fdbdbd; */
}
#cme-footer .main .footer-right {
  float: right;
  width: 360px;
  height: 80%;
}
#cme-footer .main .footer-right .footer-scan {
  width: 100%;
  height: 100%;
  position: relative;
}
#cme-footer .main .footer-right .footer-scan .img {
  width: 75px;
  height: 75px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#cme-footer .main .footer-right .footer-scan .img img {
  width: 100%;
  height: 100%;
}
#cme-footer .main .footer-right .scan-info {
  font-size: 12px;
  text-align: center;
  height: 30px;
  color: #8795a6;
  /* 过年主题 */
  /* color: #fdbdbd; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 75px;
}
#cme-footer .main .footer-right .last-right {
  float: right;
  margin-right: 40px;
}
#cme-footer .main .footer-right .last-right .last-icon .icon {
  float: left;
  margin-right: 10px;
  height: 50px;
  margin-top: 12px;
}
#cme-footer .main .footer-right .last-right .last-icon .icon img {
  height: 25px;
}
/*cme-footer 结束*/
/*cme-bottom 开始*/
#cme-bottom {
  width: 100%;
  /* height: 40px; */
  /* line-height: 40px; */
  font-size: 12px;
  overflow: hidden;
  text-align: center;
  color: #8795a6;
  background-color: #18273f;
  /* 过年主题 */
  /* background-color: #ad0300;
  color: #fdbdbd; */
}
#cme-bottom .z-container{
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  justify-content: center;
  align-items: center;
}
/*cme-bottom 结束*/

/*中机商圈头尾响应式  开始*/

@media screen   and (max-width: 767px) {
  .z-container {
    width: 100%;
  }
  #cme-footer .main {
    height: initial;
  }
  #cme-footer .main .footer-left {
    width: 275px;
    float: initial;
    background: none;
    margin: 0 auto;
    text-align: left;
  }
  #cme-footer .main .footer-center {
    width: 275px;
    float: initial;
    background: none;
    margin: 26px auto;
    text-align: left;
  }
  #cme-footer .main .footer-right {
    width: 275px;
    height: 75px;
    float: none;
    background: none;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  #cme-footer .main .footer-right .fl {
    float: none;
    display: inline-block;
  }
  #cme-footer .main .footer-right .fl:last-child .footer-scan {
    margin-right: 0;
  }
  #cme-footer .main .footer-center .center-num,
  #cme-footer .main .footer-center .center-title {
    white-space: normal;
    width: 275px;
  }
  #cme-footer .main .footer-center .center-title,
  #cme-footer .main .footer-left .center-title {
    width: 245px;
    font-size: 16px;
  }
  #cme-bottom {
    height: auto;
    line-height: 20px;
    padding: 10px 0;
  }
  .bcd-productDetail-box .commodity-show .commodity-infos .infos .width30 {
    font-size: 12px !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .z-container {
    width: 100%;
  }
  #cme-footer .main .footer-left {
    width: 28%;
  }
  #cme-footer .main .footer-center {
    width: 32%;
  }
  #cme-footer .main .footer-right {
    width: 36%;
  }
  #cme-footer .main .footer-right .fl:last-child .footer-scan {
    margin-right: 0;
  }
  #cme-footer .main .footer-left .center-title {
    width: initial;
  }
  #cme-footer .main .footer-center {
    margin-left: 20px;
  }
  #cme-footer .main .footer-center .center-title {
    width: initial;
  }
  #cme-footer .main .footer-center .center-num {
    width: initial;
  }
  #cme-footer .main .footer-left .center-tel {
    font-size: 28px;
    width: 196px;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .z-container {
    width: 100%;
  }
}

@media screen and (min-width: 1200px) {
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue